import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';

import config from '../../config/config';
import Navbar from '../../components/common/Navbar';
import ErrorFlash from '../../components/common/ErrorFlash';
import LoadingScreen from '../../components/common/LoadingScreen';

const PublicNavbar = () => {
  const navigate = useNavigate();
  return (
    <Box padding={'1em 1.5em 1em 1.5em'} style={{borderBottom: '1px solid #e0e0e0', backgroundColor: 'white'}}>
      <Stack direction='row' justifyContent='space-between'>
        <a
          href={config().marketingSiteUrl}
          target='_blank'
          rel='noreferrer'
        >
          <img
            style={{height: '50px'}}
            alt='Logo'
            src="/images/MovementX-logo.png" 
          />
        </a>
        <Button variant='text' onClick={() => navigate('/login')}>
          Login
        </Button>
      </Stack>
    </Box>
  );
};

const PublicLayout = props => {
  return (
    <Box style={{backgroundColor: props.backgroundColor || '#ffffff', minHeight: '100vh'}}>
      <Stack overflow='hidden'>
        <PublicNavbar />
        <ErrorFlash error={props.error} />
        {
          props.isLoading 
          ? <LoadingScreen />
          : props.children
        }
      </Stack>
    </Box>
  );
};

export default PublicLayout;